import {useCallback, useContext, useEffect, useState} from "react";
import {loadDataWithCache} from "../../utils";
import Image from "../../components/Gallery/components/Image/Image";
import './style.scss';
import {ProjectsContext} from "../../App";

function Bio() {
    const {imagesCache, setImagesCache} = useContext(ProjectsContext);
    const [images, setImages] = useState([]);
    const [bioText, setBioText] = useState([]);
    const getData = useCallback(async () => {
        const res = await loadDataWithCache('bio', imagesCache, setImagesCache);
        setImages(res);
        setBioText(res[0]?.context?.custom?.alt)
    }, [imagesCache, setImagesCache]);
    useEffect( () => {
        getData();
    },[getData])

    return (
        bioText
            ? (<div>
                <h1 className='bio-title'>Biography</h1>
                <div className='bio-page'>
                {images?.[0] && <Image src={images[0].public_id}/>} 
                <p className='about-me' dangerouslySetInnerHTML={{__html: bioText}}></p>
                </div>
            </div>)
            : (<div className='bio-page'>
                <p className='about-me'>Loading...</p>
                </div>)
);
}

export default Bio;
